<!--报表 历史出库单 批量出库 -->
<template>
  <div>
    <el-row>
      <el-col>
        <el-form :model="searchForm" ref="searchForm" :inline="true" size="medium">
          <el-form-item label="批次：">
            <el-input v-model="searchForm.BATCH" placeholder="请输入批次" clearable style="width: 200px"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" class="btn" @click="handleSearch">筛选</el-button>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
    <el-row>
      <el-col>
        <el-table border stripe :data="tableData" max-height="520" @selection-change="handleSelectionChange">
          <el-table-column type="selection" width="50" fixed="left" :selectable="selectable"></el-table-column>
          <el-table-column type="index" label="序号" width="50"></el-table-column>
          <el-table-column prop="ORDER_ID" label="订单ID"></el-table-column>
          <el-table-column prop="PRODUCT_NAME" label="产品名称" min-width="70px"></el-table-column>
          <el-table-column prop="PRODUCT_CODE" label="产品编号"></el-table-column>
          <el-table-column prop="TYPE_UNIT" label="产品单位"></el-table-column>
          <el-table-column prop="BATCH" label="批次"></el-table-column>
          <el-table-column prop="PRODUCT_COUNT" label="出库数量"></el-table-column>
          <el-table-column prop="RETURN_COUNT" label="退库数量"></el-table-column>
        </el-table>
        <el-button size="medium" style="margin-top: 16px;" @click="openReturnDialog">批量退库</el-button>
      </el-col>
    </el-row>
    <el-dialog title="退货信息" center :visible.sync="returnDialogVisible" width="800px">
      <el-table :data="returnList" border>
        <el-table-column type="index" label="序号" width="50"></el-table-column>
        <el-table-column prop="PRODUCT_NAME" label="产品名称" min-width="100"></el-table-column>
        <el-table-column prop="TYPE_UNIT" label="单位" width="80"></el-table-column>
        <el-table-column prop="BATCH" label="出库批次" width="80"></el-table-column>
        <el-table-column prop="PRODUCT_COUNT" label="出库数量" width="80"></el-table-column>
        <el-table-column label="库位" v-if="WAREHOUSE_MODE == 2">
          <template slot-scope="scope">
            <el-select v-model="scope.row.LOCATION_CODE" clearable filterable :filter-method="positionFilter">
              <el-option v-for="item in positionList" :key="item.ID" :value="item.CODE" :label="item.CODE">
              </el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column label="退货数量">
          <template slot-scope="scope">
            <el-input :placeholder="`最多可退${scope.row.PRODUCT_COUNT - scope.row.RETURN_COUNT} `"
              v-model="scope.row.COUNT" />
          </template>
        </el-table-column>
        <el-table-column label="退货原因">
          <template slot-scope="scope">
            <el-input v-model="scope.row.COMMENT"></el-input>
          </template>
        </el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="returnDialogVisible = false">取 消</el-button>
        <el-button size="small" @click="confirmReturn">确 定</el-button>
      </div>
    </el-dialog>
    <div class="pagination_box" style="text-align: right">
      <el-pagination @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-size="pageSize"
        layout="total,prev, pager, next, jumper" :total="totalCount">
      </el-pagination>
    </div>
  </div>
</template>
<script>
import {
  queryPosition,
  returnXMDFun,
} from 'api/warehouseManager';
import util from '@/assets/common/util';
import http from '@/assets/common/http';
import validation from '@/assets/common/validation';
import { showFullScreenLoading, tryHideFullScreenLoading } from '@/assets/plugin/loading/loading';

export default {
  data () {
    return {

      searchForm: {
      },
      tableData: [],
      allStockOutProducts: [],
      totalCount: 0,
      pageSize: 15,
      currentPage: 1,
      returnDialogVisible: false,
      returnList: [],
      positionList: [],
      allPositionList: [],
      WAREHOUSE_MODE: sessionStorage.getItem('WAREHOUSE_MODE'),
    };
  },
  created () {
    // this.fetchStockOutProducts();
    this.fetchPositions();
  },
  methods: {
    confirmReturn () {
      if (this.returnList.length === 0) {
        this.$message.show({ text: '请勾选需要退库的产品', type: 'warning' });
        return false;
      }
      const groupedItems = this.returnList.reduce((acc, item) => {
        if (!acc[item.ORDER_ID]) {
          acc[item.ORDER_ID] = {
            ID: item.ORDER_ID,
            GYS_ID: Number(sessionStorage.getItem('tcId')),
            RECORD_ID: item.RECORD_ID,
            WAREHOUSE_MODE: this.WAREHOUSE_MODE,
            DETAILS: [],
          };
        }
        acc[item.ORDER_ID].DETAILS.push({
          BATCH: item.BATCH,
          DETAIL_ID: item.ORDER_DETAIL_ID,
          PRODUCT_CODE: item.PRODUCT_CODE,
          PRODUCT_COUNT: item.COUNT,
          RETURN_REASON: item.COMMENT ? item.COMMENT : '',
          LOCATION_CODE: item.LOCATION_CODE, // 库位
          TYPE_UNIT: item.TYPE_UNIT,
        });
        return acc;
      }, {});
      const groupedItemsArray = Object.values(groupedItems);
      const flag = groupedItemsArray.every((groupItem) => groupItem.DETAILS.every(({ TYPE_UNIT, PRODUCT_COUNT }) => {
        if (util.JudgmentUnit(TYPE_UNIT)) {
          if (validation.数量两位小数正数验证(PRODUCT_COUNT)) {
            return true;
          }
        } else {
          if (validation.数量整数正数验证(PRODUCT_COUNT)) {
            return true;
          }
        }
        return false; // 如果之前的条件都不满足，则返回false
      }));
      // 退库数量不能超过可退数量（出库数量 - 已退数量）
      const countLimitFlag = this.returnList.every((item) => Number(item.COUNT) <= (Number(item.PRODUCT_COUNT) - Number(item.RETURN_COUNT)));
      const locationFlag = groupedItemsArray.some((groupItem) => groupItem.DETAILS.some((item) => !item.LOCATION_CODE));
      if (!flag) {
        this.$message.show({ text: '请输入正确的退库数量', type: 'warning' });
        return false;
      }
      if (!countLimitFlag) {
        this.$message.show({ text: '退库数量不能超过可退数量', type: 'warning' });
        return false;
      }
      if (this.WAREHOUSE_MODE == 2 && locationFlag) {
        this.$message.show({ text: '请选择库位', type: 'warning' });
        return false;
      }

      let hasError = false;
      const errList = [];
      showFullScreenLoading();
      const enqueueReturn = (promiseChain, currentTask) => promiseChain.then(() => currentTask().catch((error) => {
        hasError = true;
        errList.push(error);
      }));
      const promiseChain = groupedItemsArray.reduce((chain, item) => {
        const params = {
          ORDER_ID: item.ID,
          DETAILS: item.DETAILS,
          GYS_ID: Number(sessionStorage.getItem('tcId')),
          RECORD_ID: item.RECORD_ID,
          WAREHOUSE_MODE: sessionStorage.getItem('WAREHOUSE_MODE'),
        };
        return enqueueReturn(chain, () => returnXMDFun(params));
      }, Promise.resolve());
      promiseChain.then(() => {
        tryHideFullScreenLoading();
        if (hasError) {
          this.$message.show({ text: errList.join('；'), type: 'error' });
          return false;
        }
        this.$message.show({ text: '所有退库操作已完成', type: 'success' });
        this.returnDialogVisible = false;
        this.fetchStockOutProducts();
      }).catch(() => {
      });
    },
    positionFilter (query = '') {
      const arr = this.allPositionList.filter((item) => item.CODE && item.CODE.includes(query));
      if (arr.length > 50) {
        this.positionList = arr.slice(0, 50);
      } else {
        this.positionList = arr;
      }
    },
    fetchPositions () {
      queryPosition().then((result) => {
        this.allPositionList = result;
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    handleSelectionChange (e) {
      this.returnList = e;
    },
    openReturnDialog () {
      if (this.returnList.length == 0) {
        this.$message.show({ text: '请勾选需要退库的产品', type: 'warning' });
        return false;
      }
      // 打开弹窗前重置本次退库数量/原因/库位，避免残留上次输入
      this.returnList = this.returnList.map((item) => ({
        ...item,
        COUNT: '',
        COMMENT: '',
        LOCATION_CODE: '',
      }));
      this.returnDialogVisible = true;
    },
    selectable (row) {
      if (row.PRODUCT_COUNT == row.RETURN_COUNT) {
        return false;
      }
      return true;
    },
    handleCurrentChange (e) {
      this.currentPage = e;
      // 接口不接受分页参数，翻页时从缓存的全量数据中本地切片，无需重新请求
      const start = (this.currentPage - 1) * this.pageSize;
      this.tableData = this.allStockOutProducts.slice(start, start + this.pageSize);
    },
    handleSearch () {
      this.currentPage = 1;
      this.fetchStockOutProducts();
    },
    fetchStockOutProducts () {
      if (!this.searchForm.BATCH) {
        this.$message.show({ text: '请输入批次', type: 'warning' });
        return false;
      }
      const params = {
        SERVICE_ID: '10031',
        OTYPE: 110,
        BATCH: this.searchForm.BATCH,
      };
      http.post(params).then((res) => {
        const allData = Array.isArray(res) ? res : [];
        this.allStockOutProducts = allData;
        this.totalCount = allData.length;
        // 接口 10031-110 不接受分页参数、返回全量数据，前端本地分页展示
        const start = (this.currentPage - 1) * this.pageSize;
        this.tableData = allData.slice(start, start + this.pageSize);
        // 重新拉取后清空已勾选项，避免提交上一批次的旧数据
        this.returnList = [];
      }).catch((err) => {
        this.$message.show({ text: err, type: 'error' });
      });
    },
  },
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/tableManage/batchReturnOfInventory.vue